module.exports = __webpack_public_path__ + "img/share_and_Earn.03996e9e.jpg";